"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _useGetProductById2 = require("../../hooks/useGetProductById");

var _SelectableProductItem = _interopRequireDefault(require("./SelectableProductItem"));

var ConnectedSelectableProductItem = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _product$name, _product$denomination, _product$denomination2, _product$denomination3, _product$localPrice, _product$localPrice2, _product$images, _product$provider;

  var id = _ref.id,
      denomination = _ref.denomination,
      selected = _ref.selected,
      onClick = _ref.onClick,
      sx = _ref.sx,
      fullText = _ref.fullText,
      _ref$nameWithPrice = _ref.nameWithPrice,
      nameWithPrice = _ref$nameWithPrice === void 0 ? true : _ref$nameWithPrice,
      boxProps = (0, _objectWithoutProperties2.default)(_ref, ["id", "denomination", "selected", "onClick", "sx", "fullText", "nameWithPrice"]);

  var _useGetProductById = (0, _useGetProductById2.useGetProductById)({
    id,
    denomination
  }),
      product = _useGetProductById.product,
      isFulfilled = _useGetProductById.isFulfilled;

  var productName = (_product$name = product === null || product === void 0 ? void 0 : product.name) !== null && _product$name !== void 0 ? _product$name : '';
  return /*#__PURE__*/_react.default.createElement(_SelectableProductItem.default, (0, _extends2.default)({}, boxProps, {
    name: !!(product !== null && product !== void 0 && (_product$denomination = product.denomination) !== null && _product$denomination !== void 0 && _product$denomination.price) && nameWithPrice ? "".concat(product === null || product === void 0 ? void 0 : (_product$denomination2 = product.denomination) === null || _product$denomination2 === void 0 ? void 0 : _product$denomination2.currencySign).concat(product === null || product === void 0 ? void 0 : (_product$denomination3 = product.denomination) === null || _product$denomination3 === void 0 ? void 0 : _product$denomination3.price, " ").concat(productName) : productName,
    onClick: onClick,
    selected: selected,
    rangeDenomination: product === null || product === void 0 ? void 0 : product.rangeDenomination,
    price: product === null || product === void 0 ? void 0 : (_product$localPrice = product.localPrice) === null || _product$localPrice === void 0 ? void 0 : _product$localPrice.price,
    currencySign: product === null || product === void 0 ? void 0 : (_product$localPrice2 = product.localPrice) === null || _product$localPrice2 === void 0 ? void 0 : _product$localPrice2.currencySign,
    image: product === null || product === void 0 ? void 0 : (_product$images = product.images) === null || _product$images === void 0 ? void 0 : _product$images[0],
    countryId: product === null || product === void 0 ? void 0 : product.countryId,
    provider: (product === null || product === void 0 ? void 0 : product.hasExternalFulfillment) && (product === null || product === void 0 ? void 0 : (_product$provider = product.provider) === null || _product$provider === void 0 ? void 0 : _product$provider.name) || '',
    sx: sx,
    loading: !isFulfilled,
    fullText: fullText
  }));
});
var _default = ConnectedSelectableProductItem;
exports.default = _default;